const firebaseConfig = {
    apiKey: "AIzaSyD76YlMgBh2v_gLydM96A27F3hiSwKJ4-M",
    authDomain: "creative-agency-c9495.firebaseapp.com",
    databaseURL: "https://creative-agency-c9495.firebaseio.com",
    projectId: "creative-agency-c9495",
    storageBucket: "creative-agency-c9495.appspot.com",
    messagingSenderId: "529205023151",
    appId: "1:529205023151:web:db4de7fc480bb1ee679f5a"
  };
    export default firebaseConfig;